<template>
	<v-container class="metadata-toolbar d-flex pt-2 pb-0 px-1">
		<v-container class="d-flex align-center justify-start pa-0">
			<v-metadata-hover-icon
				draggable
				icon="mdi-drag-horizontal"
				size="small"
			/>
		</v-container>
		<v-container class="d-flex align-center justify-end pa-0">
			<v-metadata-hover-icon
				v-if="isAdmin && isStandardMode"
				icon="mdi-map-marker-outline"
				@click.stop="selectLocation($event)"
			/>
			<v-metadata-hover-icon
				v-if="expanded"
				icon="mdi-unfold-less-vertical"
				@click="collapseDialog"
			/>
			<v-metadata-hover-icon
				v-else
				icon="mdi-unfold-more-vertical"
				@click="expandDialog"
			/>
			<v-metadata-hover-icon
				icon="mdi-help-circle-outline"
				@click="toggleUserManual"
			/>
		</v-container>
	</v-container>
</template>

<script>
import { mapActions } from "pinia";
import { useMainStore } from "@/store";
import VMetadataHoverIcon from "./VMetadataHoverIcon.vue";
import { Mode } from "./VMetadataConstants.js";

export default {
	name: "VMetadataHeader",
	components: {
		VMetadataHoverIcon,
	},
	props: {
		expanded: { type: Boolean, default: true },
		isAdmin: { type: Boolean, default: false },
		mode: { type: String, default: Mode.STANDARD },
	},

	emits: ["update:expanded", "select-location"],

	setup() {},

	data() {
		return {};
	},
	computed: {
		help() {
			return useMainStore().help;
		},
		isStandardMode() {
			return this.mode === Mode.STANDARD;
		},
	},

	methods: {
		...mapActions(useMainStore, ["setHelp", "clearHelp"]),
		toggleUserManual: function () {
			if (this.help) {
				this.clearHelp();
			} else {
				this.setHelp("data-entry-keyboard-shortcuts");
			}
		},
		collapseDialog: function () {
			this.$emit("update:expanded", false);
		},
		expandDialog: function () {
			this.$emit("update:expanded", true);
		},
		selectLocation: function (event) {
			this.$emit("select-location", event);
		},
	},
};
</script>

<style lang="scss">
.metadata-toolbar {
	height: 12px;
	line-height: 12px;
	z-index: 1;
}
</style>
